module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "idea-container"
  }, [_c('div', {
    staticClass: "idea"
  }, [_c('a', {
    attrs: {
      "href": _vm.twitterIntent,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.twitterLogo
    }
  })]), _c('p', {
    attrs: {
      "id": "idea"
    }
  }, [_c('span', [_vm._v("Build something that uses ")]), _c('span', {
    staticClass: "data tech"
  }, [_vm._v(_vm._s(_vm.tech) + " ")]), _c('span', [_vm._v("to help ")]), _c('span', {
    staticClass: "data job"
  }, [_vm._v(" " + _vm._s(_vm.job))]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "data action"
  }, [_vm._v(" " + _vm._s(_vm.action))])]), _c('button', {
    style: (_vm.btnstyle),
    on: {
      "click": _vm.mixup
    }
  }, [_vm._v("Give Me an Idea!")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69748b8e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Idea.vue
// module id = 90
// module chunks = 1